import { Box, Group, type MantineSize } from '@mantine/core';
import type { ReactNode } from 'react';
import { InputSizes } from '../../../../vision-theme/src/mantine/components/Input/Input.config';
import classes from './RowActions.module.css';

type Props = {
  addAction?: ReactNode;
  removeAction?: ReactNode;
  buttonSize?: MantineSize;
};

// Empty slots preserve action alignment without rendering hidden, focusable buttons.
export function RowActions({ addAction, removeAction, buttonSize = 'sm' }: Props) {
  return (
    <Group className={classes.root} gap={10} ml="auto" wrap="nowrap">
      <Box className={classes.slot} miw={InputSizes[buttonSize]}>
        {addAction}
      </Box>
      <Box className={classes.slot} miw={InputSizes[buttonSize]}>
        {removeAction}
      </Box>
    </Group>
  );
}
